
export default {
	name: 'Hint',
	props: {
		hint: {
			type: String,
			required: true,
		},
	},
}
